/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/VideoRecorder/overlays/OverlayTop.js
 * Created:       Mon Jul 22 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React from "react";
import LeftArrowSolid from "~/assets/images/icons/fontAwesome/arrow-left-solid.svg";
import TimesSolid from "~/assets/images/icons/fontAwesome/times-solid.svg";


export default function OverlayTop({ overlayState, setOverlayState, closeModal, stopCamera }) {

  const backButtonMarkup = ( overlayState === 'thumbnail' ) ?
    <button type={"button"} className={"gc__svg_button"}
      onClick={() => {
        setOverlayState("playback-complete");
      }}
    >
      <img className={"gc__svg_filtered"} src={LeftArrowSolid} alt="" />
    </button> :
    <button type={"button"} className={"gc__svg_button"} onClick={() => {
      stopCamera();
      closeModal();
    }}>
      <img className={"gc__svg_filtered"} src={TimesSolid} alt="" />
    </button>

  const overlayTopMarkup = ( overlayState === "recording" ) ?
    <></> :
    <div className={"gc__overlay_top_container"}>
      {backButtonMarkup}
    </div>

  return (
    <>
      {overlayTopMarkup}
    </>
  );
}
